import _ from "lodash";
import { globalAssets } from "../../../assets/global/assets";

const assets = {
  ...globalAssets,
  background_1920: require("../../../assets/of/videos/background_1920x1080_v2.webm"),
};

export default assets;
